import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-75ef534c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "data" }
const _hoisted_3 = {
  level: 6,
  style: {"color":"#1E90FF"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_the_ebooks_card = _resolveComponent("the-ebooks-card")!
  const _component_a_divider = _resolveComponent("a-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ebooks, (row) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: row.id
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_typography_title, { level: 5 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(row.parent.name), 1)
            ]),
            _: 2
          }, 1024),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.children, (child) => {
            return (_openBlock(), _createElementBlock("div", {
              key: child.category.id,
              class: "list"
            }, [
              _createElementVNode("h4", _hoisted_3, _toDisplayString(child.category.name), 1),
              _createVNode(_component_the_ebooks_card, {
                data: child.ebooks
              }, null, 8, ["data"])
            ]))
          }), 128))
        ]),
        _createVNode(_component_a_divider)
      ], 64))
    }), 128))
  ]))
}